import { InactiveCourse } from './inactivecourse';

export const InactiveModule = () => {
  return <InactiveCourse isModule={true} />;
};
